import { jsx as _jsx } from "react/jsx-runtime";
const SvgColorValue = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", ...props, children: _jsx("rect", { width: 22, height: 22, x: 1, y: 1, fill: "currentColor", rx: 4 }) }));
export default SvgColorValue;
